var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.92276 8.95795L8.3597 6.18426H5.66816V4.38136C5.66816 3.62293 6.04393 2.88183 7.24551 2.88183H8.48642V0.519854C7.76377 0.40472 7.03357 0.342433 6.30172 0.333496C4.08644 0.333496 2.64017 1.664 2.64017 4.06932V6.18426H0.18457V8.95795H2.64017V15.6668H5.66816V8.95795H7.92276Z",
    fill: "#337FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookSmall);
export default __webpack_public_path__ + "static/media/facebook-small.e6dcf96457e655a6cee95af844fe7382.svg";
export { ForwardRef as ReactComponent };